<template>
  <div class="json-display">
    <span v-if="expanded" @click="expanded = false" title="collapse"> {{ full }} </span>
    <span v-else @click="expanded = true" title="expand"> {{ summary }} </span>
  </div>
</template>
<script>
import { summarizeObject } from '@/utilities';

export default {
  name: 'JSONDisplay',
  props: ['obj'],
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    summary() { return summarizeObject(this.obj); },
    full() { return JSON.stringify(this.obj, null, 2); },
  },
};
</script>
<style lang="scss" scoped>
  span {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/JSONDisplay.vue